/**
 * Created by Jerker Nord on 2019-03-12.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {ThorAnimatedWinlinesView} from "./ThorAnimatedWinlinesView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ThorParsedInitData} from "../../server/data/ThorParsedInitData";

export class ThorAnimatedWinlineController extends BaseController {

    public static readonly PLAY_ANIMATED_WINLINE:string = "ThorAnimatedWinlinesView_playAnimatedWinline";
    public static readonly CLEAN_UP_ANIMATED_WINLINE:string = "ThorAnimatedWinlinesView_cleanUpAnimatedWinline";

    private _view:ThorAnimatedWinlinesView;

    constructor() {
        super();
        this._view = new ThorAnimatedWinlinesView();
        this.addEventListeners();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ThorAnimatedWinlineController.PLAY_ANIMATED_WINLINE, (event:GameEvent):void => this.playAnimatedWinline(event.params[0]));
        EventHandler.addEventListener(this, ThorAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE, (event:GameEvent):void => this.cleanUpAnimatedWinlines());
    }

    private onInitDataParsed(data:ThorParsedInitData):void {
        this._view.betLinesData = data.betLines;
    }

    private playAnimatedWinline(winLine:number):void {
        this._view.getWinlineTL(winLine).play();
    }

    private cleanUpAnimatedWinlines():void {
        this._view.getCleanUpWinlinesTL().play();
    }
}